import request from '@/utils/request';
import qqMapRequest from '@/utils/qqMapRequest.js';

// 获取订单定位轨迹
export function getDriverPositionApp(id){
  return request({
    url:'/logistic/app/api/orderselect/new/appGetPositionInfo/'+id,
    method:'GET',
  })
}

// 获取分享订单定位轨迹
export function getAllDriverPositionApp(id){
	return request({
	  url:'/logistic/app/api/orderselect/withoutPermission/new/appGetPositionInfo/'+id,
	  method:'GET',
	})
}

// 获取VIP订单定位轨迹
export function getDriverPositionVip(id){
	return request({
		url:'/logistic/vipapp/api/orderselect/new/getPositionInfo/'+id,
		method:'GET',
	})
}

// 获取VIP订单定位轨迹
export function getAllDriverPositionVip(id){
	return request({
		url:'/logistic/vipapp/api/orderselect/withoutPermission/new/getPositionInfo/'+id,
		method:'GET',
	})
}


// 修改卸货地获取隐私号码
export function getVirtualPhoneNumber(data){
	return request({
		// url:'/cloudservice/app/api/pnp/bindPhone',
		url:'/cloudservice/app/api/pnp/bindModifyEndAddressPhone',
		method:'POST',
		data,
	})
}
// 普通获取隐私号码
export function getVirtualPhoneNumberBynormal(data){
	return request({
		url:'/cloudservice/app/api/pnp/bindPhone',
		method:'POST',
		data,
	})
}

// 普通获取隐私号码
export function getVipVirtualPhoneNumberBynormal(data){
	return request({
		url:'/cloudservice/vipapp/api/pnp/bindPhone',
		method:'POST',
		data,
	})
}


// 检查是否已经拨打过电话
export function getcheckCalled(params){
	return request({
		url:'/cloudservice/app/api/pnpInfo/checkConnectRecords',
		method:'GET',
		params,
	})
}

export function geocoder(params) { 
  return qqMapRequest({
      url:'/ws/geocoder/v1',
      method:'GET',
      params
  })
}

/* 驾车（driving）路线规划 */
export function directionDriving(params){
  return qqMapRequest({
    url:'/ws/direction/v1/trucking',
    method:'GET',
    params
  })
}

// 获取订单详情
export function getOrderDetails(id){
	return request({
		url:'/logistic/app/api/ownOrder/selectOwnOrder/'+id.id,
    method:'GET',
	})
}

// 获取分享订单详情
export function getAllOrderDetails(id){
	return request({
		url:'/logistic/app/api/ownOrder/withoutPermission/selectOwnOrder/'+id.id,
    	method:'GET',
	})
}

// VIP获取企业个人订单详情
export function getVipOrderDetails(id){
	return request({
		url:'/logistic/vipapp/api/vipTransportOwnOrder/selectOwnOrder/'+id.id,
    method:'GET',
	})
}

// VIP获取企业个人订单详情
export function getVipAllOrderDetails(id){
	return request({
		url:'/logistic/vipapp/api/vipTransportOwnOrder/withoutPermission/selectOwnOrder/'+id.id,
    method:'GET',
	})
}


// VIP获取企业所有订单详情
export function getVipDeptOrderDetails(id){
	return request({
		url:'/logistic/vipapp/api/vipTransportOwnOrder/companyOrDeptOrder/'+id.id,
    method:'GET',
	})
}

// 企业查看所有企业订单详情
export function vipgetAllOrderdDeptDetails(id){
	return request({
		url:'/logistic/vipapp/api/vipTransportOwnOrder/withoutPermission/companyOrDeptOrder/'+id.id,
		method:'GET'
	})
}

// 获取司机详情信息
export function getDriverDetails(id){
	return request({
		url:'/basic/app/api/driverInfo/findDriverInfoAndCarInfoByDriverId/'+id.id,
    method:'GET',
	})
}

// 获取分享订单司机详情信息
export function getAllDriverDetails(id){
	return request({
		url:'/basic/app/api/driverInfo/withoutPermission/findDriverInfoAndCarInfoByDriverId/'+id.id,
    method:'GET',
	})
}

// vip获取司机详情信息
export function vipGetDriverDetails(id){
	return request({
		url:'/basic/vipapp/api/driverInfo/findDriverInfoAndCarInfoByDriverId/'+id.id,
    method:'GET',
	})
}

// vip获取分享订单司机详情信息
export function getAllVipGetDriverDetails(id){
	return request({
		url:'/basic/vipapp/api/driverInfo/withoutPermission/findDriverInfoAndCarInfoByDriverId/'+id.id,
    method:'GET',
	})
}

// 查看物流节点
export function checkTrackList(params){
	return request({
		// url:'/logistic/orderTrack/findOrderTrackByOrderId',
    url:'/logistic/app/api/orderselect/gettracklist',
    method:'GET',
		params,
	})
}
// 查看分享订单物流节点
export function getAllCheckTrackList(params){
	return request({
    url:'/logistic/app/api/orderselect/withoutPermission/gettracklist',
    method:'GET',
		params,
	})
}
// vip查看物流节点
export function vipCheckTrackList(params){
	return request({
    url:'/logistic/vipapp/api/orderselect/gettracklist',
    method:'GET',
		params,
	})
}
// vip查看物流节点
export function getAllVipCheckTrackList(params){
	return request({
    url:'/logistic/vipapp/api/orderselect/withoutPermission/gettracklist',
    method:'GET',
		params,
	})
}


// 获取字典
export function apigetDriction(){
  return request({
    url:'/system/app/api/dict/data/type/beecargo_node',
    method:'GET',
  })
}

// 分享订单获取字典
export function apiAllGetDriction(){
	return request({
		url:'/system/app/api/dict/data/withoutPermission/type/beecargo_node',
		method:'GET',
	})
}
// vip获取字典
export function apivipGetDriction(){
  return request({
    url:'/system/vipapp/api/dict/data/type/beecargo_node',
    method:'GET',
  })
}

// 分享订单vip获取字典
export function apiAllVipGetDriction(){
	return request({
	  url:'/system/vipapp/api/dict/data/withoutPermission/type/beecargo_node',
	  method:'GET',
	})
  }

// 判断订单是否可以修改地址
export function apicanFixAddressFlag(data){
	return request({
	  url:'/logistic/app/api/ownOrder/canModifyEndAddress',
	  method:'POST',
	  data
	})
}

// 创建修改地址订单
export function apicreateFixOrder(data){
	return request({
	  url:'/logistic/app/api/modifyQuotation/createModifyAddressOrder',
	  method:'POST',
	  data
	})
}

// 查询修改前和修改后的订单地址
export function apiInquireFixAddress(params){
	return request({
	  url:'/logistic/app/api/modifyQuotation/selectModifySuccessOrder',
	  method:'GET',
	  params
	})
}

// 提交修改地址中补偿司机订单
export function apicompensateDriver(data){
	return request({
	  url:'/logistic/app/api/modifyQuotation/createModifyAddrMarkupOrder',
	  method:'POST',
	  data
	})
}

// 取消修改地址
export function apicancelFixAddress(data){
	return request({
	  url:'/logistic/app/api/modifyQuotation/cancelModifyAddressOrder',
	  method:'POST',
	  data
	})
}

// 退款修改地址
export function apirefundFixAddress(params){
	return request({
	  url:'/logistic/app/api/modifyQuotation/refundModifyAddressOrder',
	  method:'GET',
	  params
	})
}
// 修改地址中查询修改地址
export function apireadFixAddress(params){
	return request({
	  url:'/logistic/app/api/modifyQuotation/selectModifyNeedPayOrder',
	  method:'GET',
	  params
	})
}

// 取消修改地址
export function apiCancelFixAddressOrder(data){
	return request({
	  url:'/logistic/app/api/modifyQuotation/cancelModifyAddressOrder',
	  method:'POST',
	  data
	})
}
// 获取vip字典，指定企业不回显
export function apigetDeptDiction(params){
	return request({
	  url:'/system/app/api/dict/data/type/vip_view_union_dept_id_list_key',
	  method:'GET',
	  params
	})
}

// 获取分享订单vip字典，指定企业不回显
export function apiAllGetDeptDiction(params){
	return request({
	  url:'/system/app/api/dict/data/withoutPermission/type/vip_view_union_dept_id_list_key',
	  method:'GET',
	  params
	})
}


// 获取vip字典，指定企业不回显
export function apiVipgetDeptDiction(params){
	return request({
	  url:'/system/vipapp/api/dict/data/type/vip_view_union_dept_id_list_key',
	  method:'GET',
	  params
	})
}
// 获取分享订单vip字典，指定企业不回显
export function apiAllVipgetDeptDiction(params){
	return request({
	  url:'/system/vipapp/api/dict/data/withoutPermission/type/vip_view_union_dept_id_list_key',
	  method:'GET',
	  params
	})
}

// 获取vip字典，指定企业不回显节点照片
export function apigetHideNodeImageDept(params){
	return request({
	  url:'/system/app/api/dict/data/type/vip_view_hideNodeImage_key',
	  method:'GET',
	  params
	})
}

// 获取分享订单vip字典，指定企业不回显节点照片
export function apiAllGetHideNodeImageDept(params){
	return request({
	  url:'/system/app/api/dict/data/withoutPermission/type/vip_view_hideNodeImage_key',
	  method:'GET',
	  params
	})
}


// 获取vip字典，指定企业不回显节点照片
export function apiVipgetHideNodeImageDept(params){
	return request({
	  url:'/system/vipapp/api/dict/data/type/vip_view_hideNodeImage_key',
	  method:'GET',
	  params
	})
}
// 获取分享订单vip字典，指定企业不回显节点照片
export function apiAllVipHideNodeImageDept(params){
	return request({
	  url:'/system/vipapp/api/dict/data/withoutPermission/type/vip_view_hideNodeImage_key',
	  method:'GET',
	  params
	})
}

// 获取ICCS订单详情
export function apigetIccsOrderDetails(id){
	return request({
	  url:'/logistic/vipapp/api/vipTransportOwnOrder/unionCompanyOrDeptOrder/'+id,
	  method:'GET',
	})
}

// 获取ICCS订单详情
export function getFixaddressDetail(params){
	return request({
	  url:'/logistic/driverapp/api/order/getChangeAddrDetail',
	  method:'GET',
	  params
	})
}